import React from "react";

import { ApiRequests } from "../components/api_requests/ApiRequests";
import { Management as CalendarManagement } from "../components/calendar/Management";
import { Management as UserManagement } from "../components/users/Management";
import { Management as VideoPlatformManagement } from "../components/video_platform/Management";
import { NewMeetingPage } from "../components/video_platform/NewMeetingPage";
import { ModerationManagement, ConfigurationPage } from "../components/moderation";
import { MainLayout, ScreenInfo } from "../components/layout";

const screens: ScreenInfo[] = [
  {
    id: "userManagement",
    name: "User Management",
  },
  {
    id: "calendarManagement",
    name: "Calendar Management",
  },
  {
    id: "videoPlatform",
    name: "Video Platform",
    children: [
      {
        id: "newMeeting",
        name: "New Meeting",
      },
      {
        id: "moderation",
        name: "Moderation",
        children: [
          {
            id: "moderationConfig",
            name: "Configuration",
          },
        ],
      },
    ],
  },
  {
    id: "apiRequests",
    name: "API Requests",
  },
];

const screenComponents: Record<string, () => JSX.Element> = {
  userManagement: () => <UserManagement />,
  calendarManagement: () => <CalendarManagement />,
  videoPlatform: () => <VideoPlatformManagement />,
  newMeeting: () => <NewMeetingPage />,
  moderation: () => <ModerationManagement />,
  moderationConfig: () => <ConfigurationPage />,
  apiRequests: () => <ApiRequests />,
};

export const Home = () => {
  const [activeScreenId, setActiveScreenId] = React.useState(() => {
    // Load last active screen from localStorage
    const saved = localStorage.getItem("activeScreenId");
    // Only use saved value if it's a valid screen ID
    if (saved && screenComponents[saved]) {
      return saved;
    }
    return "userManagement";
  });

  const handleSetActiveScreen = (screenId: string) => {
    setActiveScreenId(screenId);
    localStorage.setItem("activeScreenId", screenId);
  };

  return (
    <MainLayout
      screens={screens}
      activeScreenId={activeScreenId}
      onNavigate={handleSetActiveScreen}
    >
      {screenComponents[activeScreenId] ? React.createElement(screenComponents[activeScreenId]) : null}
    </MainLayout>
  );
};
